import { useState } from "react"
import Button from "components/button"
import textServices from "services/text-services"
import useRouter from "hooks/use-router"
import { SubTitleSignUpWelcome, TextSignUpWelcome, TitleSignUpWelcome } from "../styles/custom.style"
import Otp from "./otp"

interface IProps {
  name: string;
  email: string;
  handleConfirm: (data: any) => void;
}

function Welcome({ name = '', email = '', handleConfirm }: IProps) {

  const { history } = useRouter()
  const [otp, setOtp] = useState(false)

  if (otp) return <Otp email={email} handleConfirm={handleConfirm} />

  const handleClick = () => {
    gtag('event', 'verificar', {
      event_label: 'Registro - Email',
      method: "Email"
    })
    setOtp(true)
  }

  return (
    <section className="flex flex-col flex-1 w-full items-center justify-center p-7">
      <article className="flex-1 flex flex-col items-center justify-center gap-8 text-center w-full">
        <TitleSignUpWelcome className="text-center text-5xl w-full whitespace-nowrap overflow-ellipsis overflow-hidden">
          {textServices.findByText('signup/welcome/title', <>¡HOLA,<br />{name}!</>)}
        </TitleSignUpWelcome>
        <SubTitleSignUpWelcome>{textServices.findByText('signup/welcome/subtitle', 'Nos falta validar tu cuenta')}</SubTitleSignUpWelcome>
        <TextSignUpWelcome>{textServices.findByText('signup/welcome/description', 'Te enviamos un código de 6 dígitos a tu correo electrónico para que valides')}</TextSignUpWelcome>
        <TextSignUpWelcome>{textServices.findByText('signup/welcome/description2', <>Una contraseña de un solo uso se envió a <b>{email}</b></>)}</TextSignUpWelcome>
        <div>
          <TextSignUpWelcome>{textServices.findByText('signup/welcome/description3', <b>¿No la recibiste?</b>)}</TextSignUpWelcome>
          <TextSignUpWelcome className="underline">{textServices.findByText('signup/welcome/button-resend', 'Reenviar código')}</TextSignUpWelcome>
        </div>
      </article>
      <Button onClick={handleClick}>VERIFICAR CUENTA</Button>
      <button
        type="button"
        className="cursor-pointer mt-3"
        onClick={() => { history.goBack() }}
      >
        <p className='din text-center mt-3 hover:text-red-100 uppercase underline' style={{ fontSize: 10 }}>
          SALIR
        </p>
      </button>
    </section>
  )
}

export default Welcome